import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { COMPANY, PARAMETERS } from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown,} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const Parameters = () => {


        toastr.options = TOAST_OPTIONS;

        const [modal_parameters, setmodal_parameters] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [qualityParameters, setQualityParameters] = useState([]);
        const [parameterDetails, setParameterDetails] = useState(null);
        const [isloading, setIsloading] = useState(false);
        const [pType, setPType] = useState(['Physical', 'Chemical','Biological']);

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_parameters = () => {
        setmodal_parameters(!modal_parameters);
        removeBodyCss();
        }

        const fetchData = () => {
          setIsloading(true)
          axios.get(PARAMETERS, Config)
            .then((r)=>{ 
              setQualityParameters(r.data);
              setIsloading(false)
            })
            .catch((e)=>{  
              console.log(e); 
              setIsloading(false)
            });
            
        }
        
        useEffect(() => {
          
          fetchData();
          
        },[]);

        const handleAddParameter = () => {  
          setIsloading(true)
          const parameterType = document.getElementsByClassName('parameterType')[0].value;
          const parameterName = document.getElementsByClassName('parameterName')[0].value;
          const parameterUnit = document.getElementsByClassName('parameterUnits')[0].value;
          const standard      = document.getElementsByClassName('paramStandard')[0].value;
          const instruments   = document.getElementsByClassName('instruments')[0].value;
          let data = {};
          if (isEdit) {
                data = {
                    "action"    : "update",
                    "id"        : parameterDetails.id, 
                    "type"      : parameterType,
                    "name"      : parameterName,
                    "unit"      : parameterUnit,
                    "standard"  : standard,
                    "instruments"   : instruments
                }
                
          }else{
                data = {
                  "action"    : "add",
                  "type"      : parameterType,
                  "name"      : parameterName,
                  "unit"      : parameterUnit,
                  "standard"  : standard,
                  "instruments"   : instruments
                }
          }
          axios.post(PARAMETERS, JSON.stringify(data), Config)
            .then((r)=>{
 
              if(r.data.status == '0'){
                toastr.error(r.data.message); 
              }else{
                toastr.success(r.data.message); 
                fetchData();
                tog_parameters();
                setIsEdit(false)
              }
            })
            .catch((e)=>{
              console.log(e);
            });
            setIsloading(false)
        }
        
        const handleClickEdit = (row) => {
          
          tog_parameters(); 
          setIsEdit(true); 
          setParameterDetails( {id : row.id, type: row.type, name : row.name, standard : row.standard, unit : row.unit, instrument  : row.instrument} )
          
        }

        const handleAddParam = () => {
          
          setIsEdit(false);
          setParameterDetails(null) 
          tog_parameters(); 
          
        }

        const { SearchBar } = Search;
        const columns = [
        {
          dataField: 'name',
          text: 'Parameter',
          sort: true
        }
        ,
        {
          dataField: 'type',
          text: 'Type',
          sort: true
        },
        {
          dataField: 'unit',
          text: 'Units',
          sort: true
        },
        {
          dataField: 'standard',
          text: 'Standard Value',
          sort: true
        },
        {
          dataField: 'instrument',
          text: 'Instruments',
          sort: true
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'type',
          order: 'desc'
        }];
        function actionFormatter(cellContent, row){
          return(
            <>
            <Button
                type="button"
                color="info"
                onClick={() => { handleClickEdit(row); }}
                className="btn-sm btn-rounded">
                Details
            </Button>
          </>
          )
        }

        return (
            <>
              <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Quality Parameters | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                        
                        <Modal
                                  isOpen={modal_parameters}
                                  toggle={() => {
                                    tog_parameters();
                                  }}
                                  centered
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit Parameter ': 'Add Parameter' }</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_parameters(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <Form>
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Type
                                      </Label>
                                      <Col sm={12}>
                                          <select className="form-control parameterType">
                                          { parameterDetails ? <option value={parameterDetails.type}>{parameterDetails.type}</option> : <option>Select</option> }
                                          {pType.map((t,k)=>(
                                            <option key={k} value={t}>{t}</option>
                                          ))}
                                          </select>
                                      </Col>
                                    </div>
                          
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Name
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control parameterName" 
                                          placeholder="e.g pH"
                                          defaultValue={ parameterDetails ? parameterDetails.name : "" }
                                        />
                                      </Col>
                                    </div>
                                    
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Units
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control parameterUnits"
                                          placeholder=""
                                          defaultValue={ parameterDetails ? parameterDetails.unit : "" }
                                        />
                                      </Col>
                                    </div>
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                        Standard value/range
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control paramStandard"
                                          placeholder=""
                                          defaultValue={ parameterDetails ? parameterDetails.standard : "" }
                                        />
                                      </Col>
                                    </div>
                                    <div className="row mb-4">
                                      <Label
                                        htmlFor="horizontal-email-Input"
                                        className="col-sm-12 col-form-label"
                                      >
                                        Instruments (separated by commas)
                                      </Label>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control instruments"
                                          placeholder=""
                                          defaultValue={ parameterDetails ? parameterDetails.instrument : "" }
                                        />
                                      </Col>
                                    </div>
                                    </Form>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        tog_parameters();
                                      }}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick = {()=>{handleAddParameter()}}
                                    >
                                      Save...
                                    </button>
                                  </div>
                                </Modal>

                        <Row>
                        

                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">{(qualityParameters || []).length} Parameters</h5>
                                <CardBody>

                                
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ qualityParameters }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            
                                            <Row className='mb-5'>
                                                  <Col lg={8} className='mb-1'>
                                                    <div  className="rounded bg-light d-grid gap-2">
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={4}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn"
                                                        onClick = {handleAddParam}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add parameter
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ qualityParameters } 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                           
                               
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Parameters;